<template>
  <div class="staff-page">
    <div class="staff-page-main">
      <el-card class="staff-card-body" v-loading="isLoading">
        <div class="staff-info">
          <div class="title">
            <i class="el-icon-user"></i>
            <span>基本信息</span>
          </div>
          <div class="container">
            <div>
              <span>员工姓名：</span><span>{{staff && staff.userName || ''}}</span>
            </div>
            <div>
              <span>公司名称：</span><span>{{staff && staff.userCompanyName || ''}}</span>
            </div>
            <div>
              <span>联系方式：</span><span>{{staff && staff.userPhoneNumber || ''}}</span>
            </div>
          </div>
        </div>
        <div class="staff-incharge-plotMgmt">
          <div class="title">
            <i class="el-icon-setting"></i>
            <span>员工权限配置</span>
          </div>
          <div class="container" style="padding-top:20px;">
            <el-table :data="roleConfigData"
                      style="width: 100%"
                      border
                      size="mini">
              <el-table-column label="授权组织" min-width="310" align="center">
                <template slot-scope="scope">
                  <!-- 鼠标悬停 授权组织 时的弹出框 -->
                  <el-popover
                    v-if="scope.row.permissionOrgIDs.length > 0"
                    placement="top-start"
                    width="400"
                    trigger="click">
                    <div style="height:240px;overflow:auto;">
                      <span v-for="(item, index) in scope.row.permissionOrgIDs" :key="index" style="display:inline-block;margin:5px;">
                        {{orgID2OrgNameMap[item] && orgID2OrgNameMap[item].name}}
                      </span>
                    </div>
                    <span slot="reference">
                      <span style="display:inline-block;width:100%;cursor:pointer;" v-if="scope.row.permissionOrgIDs.length < 7">
                        <span v-for="(item, index) in scope.row.permissionOrgIDs" :key="index">
                          {{orgID2OrgNameMap[item] && orgID2OrgNameMap[item].name}}
                        </span>
                      </span>
                      <span style="display:inline-block;width:100%;cursor:pointer;" v-else>
                        <span v-for="(item, index) in scope.row.permissionOrgIDs.slice(0, 6)" :key="index">
                          {{orgID2OrgNameMap[item] && orgID2OrgNameMap[item].name}}
                          {{index === 5 ? `等${scope.row.permissionOrgIDs.length}个组织` : ''}}
                        </span>
                      </span>
                    </span>
                  </el-popover>
                  <el-button style="margin-top:4px;color:#b2b2b2;" size="mini" @click="onSelectOrg(scope.$index)">
                    请选择组织<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="角色权限" min-width="120" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" @click="onSelectRole(scope.$index)" :style="{color: scope.row.permissionRoleID ? '#000' : '#b2b2b2'}">
                    {{allRolesMap[scope.row.permissionRoleID] || '请选择角色'}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="数据权限" min-width="120" align="center">
                <template slot-scope="scope">
                  <el-select size="mini"
                             v-model="scope.row.onlyUserOwnData"
                             clearable
                             placeholder="请选择"
                             @change="onDataAuthSelectChange($event, scope.$index)">
                    <el-option label="仅本人数据" :value="true"></el-option>
                    <el-option label="授权组织数据" :value="false"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="时间权限" min-width="220" align="center">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.timeRange"
                                  value-format="timestamp"
                                  size="mini"
                                  type="daterange"
                                  range-separator="-"
                                  unlink-panels
                                  start-placeholder="请选择时间"
                                  end-placeholder="请选择时间">
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="指定资源id" min-width="160" align="center">
                <template slot-scope="scope">
                  <el-input placeholder="资源IDs" v-model="scope.row.permissionByDesignationIDs" size="mini" clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column min-width="110" align="center">
                <template slot="header">
                  <el-button size="mini" @click="addTableRow" type="primary">新增</el-button>
                </template>
                <template slot-scope="scope">
                  <el-tooltip effect="dark"
                              v-if="companyReaderRole && (scope.row.permissionRoleID !== companyReaderRole.roleID)"
                              :content="'一键配置['+companyReaderRole.roleSummaryCn+']角色'"
                              placement="top">
                    <el-button @click="onShortcutsCreateRow(scope.$index)" icon="el-icon-s-tools" circle></el-button>
                  </el-tooltip>
                  <el-button @click="onDeleteTableRow(scope.$index)" icon="el-icon-delete-solid" circle></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>
    </div>
    <div class="staff-page-footer">
      <el-button size="mini" @click="goBack" type="info" plain style="width:80px;">返 回</el-button>
      <el-button size="mini" @click="saveRoleConfig" type="primary" style="width:80px;margin-left:100px;">保 存</el-button>
    </div>
    <div class="dialog-container">
      <el-dialog title="请选择组织"
                 :visible.sync="orgDialogVisible"
                 width="600px"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :show-close="false"
                 center>
        <div class="dialog-main">
          <el-card class="box-card">
            <div slot="header" v-if="roleConfigData.length > 0 && currRowIndex > -1 && roleConfigData[currRowIndex]">
              <span style="margin-right:20px;">关联基地数量</span>
              <span>{{roleConfigData[currRowIndex].userSelectPlotMgmtList.length + '/' + allPlotMgmtCount}}</span>
            </div>
            <el-input
              placeholder="请输入公司名称"
              prefix-icon="el-icon-search"
              v-model="orgSearchKey"
              size="small"
              clearable>
            </el-input>
            <div class="tree-container">
              <el-tree
                show-checkbox
                node-key="nodeID"
                :props="orgProps"
                :data="plotMgmtDataCopy"
                :key="orgKey"
                :filter-node-method="filterNode"
                :load="loadOrgNode"
                ref="orgTree"
                highlight-current
                @check-change="onOrgNodeCheckStateChange"
                @check="onOrgNodeCheck"
                check-strictly
                :default-expanded-keys="defaultExpandedOrgKeys">
              </el-tree>
            </div>
          </el-card>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSelectOrgCancel" size="small">取消</el-button>
          <el-button @click="onSelectOrgConfirm" type="primary" size="small" style="margin-left:50px;">保存</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="dialog-container">
      <el-dialog title="请选择员工角色"
                 :visible.sync="roleDialogVisible"
                 width="600px"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :show-close="false"
                 center>
        <div class="dialog-main">
          <el-card class="box-card">
            <el-input
              placeholder="请输入公司名称/角色名称"
              prefix-icon="el-icon-search"
              v-model="roleSearchKey"
              size="small"
              clearable>
            </el-input>
            <div class="tree-container single-select">
              <el-tree
                show-checkbox
                node-key="nodeID"
                :default-checked-keys="defaultCheckedRoleArray"
                :props="roleProps"
                :data="roleTreeData"
                :key="roleKey"
                :filter-node-method="filterNode"
                :load="loadRoleNode"
                ref="roleTree"
                highlight-current
                check-strictly
                @check-change="onRoleNodeSelectChange">
              </el-tree>
            </div>
          </el-card>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSelectRoleCancel" size="small">取消</el-button>
          <el-button @click="onSelectRoleConfirm" type="primary" size="small" style="margin-left:50px;">保存</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="dialog-container">
      <el-dialog :visible.sync="shortcutsDialogVisible"
                 width="400px"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :show-close="false"
                 center>
        <div class="dialog-main" style="padding-left:20px;">
          <el-radio-group v-model="shortcutsSelectValue">
            <el-radio :label="1" style="margin-bottom:25px;">{{companyReaderRole && companyReaderRole.roleSummaryCn}}，仅限于公司一级组织</el-radio>
            <el-radio :label="2">{{companyReaderRole && companyReaderRole.roleSummaryCn}}，公司及以下所有组织</el-radio>
          </el-radio-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onShortcutsCancel" size="small">取消</el-button>
          <el-button @click="onShortcutsConfirm" type="primary" size="small" style="margin-left:50px;">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getRequest, postRequest } from 'utils/http-service'
import { URL_ALL_PLOTMGMT, URL_ALL_ROLES, URL_USER_AUTHORIZATION_DETAILS } from '../../constants/url'
import { OrganizationTypeEnum } from 'utils/OrganizationTypeEnum.js'
import { COMPANY_READER_ROLE_CODE } from '../../constants/roleCode.js'

export default {
  name: 'staff-role-configure',

  data () {
    return {
      userID: '', // 员工id
      action: '', // 编辑(put) or 查看(get)

      orgDialogVisible: false,
      orgSearchKey: '',
      orgProps: {
        children: 'children',
        label: 'orgNodeName'
      },
      plotMgmtData: [], // 系统中所有的组织节点树
      plotMgmtDataCopy: [], // 每次选择组织节点时展示的组织节点树
      orgKey: 1,
      nodesPreCheck: [], // 存储了在一次check中，所有选中状态被改变的节点的列表
      userSelectedOrgIDs: [], // 用户每次在组织节点树中选择的组织节点

      roleDialogVisible: false,
      roleSearchKey: '',
      defaultCheckedRoleArray: [],
      roleProps: {
        children: 'children',
        label: 'roleNodeName'
      },
      roleTreeData: [], // 选择角色时根据所选组织节点动态变化的角色树
      roleKey: 1,

      roleConfigData: [], // 员工权限配置表格内容数据，结构见下方 rowTemplate
      staff: null, // 员工基本信息
      isLoading: false,
      roleTreeMap: {}, // like {companyID: {nodeID, roleNodeName, parentID, children: [{nodeID, roleNodeName, parentID}, ...], childrenMap: {nodeID: roleNodeName}}, ...}
      allRolesMap: {}, // like {roleID: roleName}
      orgID2OrgNameMap: {}, // like {orgID: {id, isPlotMgmt, name, parentID, type}, ...}
      rowTemplate: {
        companyList: [], // 用户选中所有组织节点所对应的公司ID列表
        userSelectPlotMgmtList: [],
        permissionOrgIDs: [], // 用户选中的所有组织节点
        transitive: true, // 选中组织节点是否向下传递
        permissionRoleID: '', // 用户选中的角色ID
        onlyUserOwnData: null, // 是否只能看到自己创建的数据
        timeRange: [], // 权限生效日期范围
        permissionByDesignationIDs: '' // 指定资源IDs，以英文逗号分隔
      },
      currRowIndex: null, // 选则组织节点和用户角色时，当前选中行的index
      isFirstOrgTree: true, // 除第一次打开组织节点树，以后每次打开都需要重新渲染el-tree组件
      isFirstRoleTree: true, // 同上(角色树)
      publicOrgRoleID: '', // 公共角色所在公司ID
      currCompanyList: [], // 点击选择组织按钮时，当前选中行的已选中组织节点对应的公司ID列表
      allPlotMgmtCount: 0,
      allRolesCode2RolesIDMap: null,
      shortcutsDialogVisible: false,
      shortcutsSelectValue: null,
      companyReaderRole: null, // 快捷操作的虚拟角色{roleID, roleSummaryCn}
      defaultExpandedOrgKeys: [],
      plotMgmtList: [], // 每次计算任一行配置用户选中的基地数量时，作为临时变量使用
      rootOrgID: ''
    }
  },

  watch: {
    orgSearchKey (val) {
      // 调用组织树绑定的搜索方法
      this.$refs.orgTree.filter(val)
    },

    roleSearchKey (val) {
      // 调用角色树绑定的搜索方法
      this.$refs.roleTree.filter(val)
    },

    orgDialogVisible (val) {
      // 关闭Dialog时，清除当前搜索的key
      this.orgSearchKey = ''
    },

    roleDialogVisible (val) {
      // 关闭Dialog时，清除当前搜索的key
      this.roleSearchKey = ''
    }
  },

  created () {
    this.userID = this.$route.params.userID
    this.action = this.$route.params.action
    this.fetchAllInfo()
  },

  beforeRouteLeave (to, from, next) {
    this.$destroy()
    next()
  },

  methods: {
    // 获取系统中所有组织节点、角色以及当前用户配置信息
    fetchAllInfo () {
      this.isLoading = true

      this.fetchAllOrgList()
        .then(orgTreeList => {
          if (orgTreeList.length === 0) {
            this.$message({
              type: 'warning',
              showClose: true,
              message: '当前暂无授权组织数据！',
              offset: 300
            })
          } else {
            this.defaultExpandedOrgKeys = [orgTreeList[0].nodeID]
            this.rootOrgID = orgTreeList[0].nodeID
          }

          this.plotMgmtData = orgTreeList

          return this.fetchAllRoles()
        })
        .catch(err => {
          return Promise.reject(err)
        })
        .then(res => {
          let { roleTreeMap, allRolesMap, allRolesCode2RolesIDMap } = res

          if (Object.keys(roleTreeMap).length === 0) {
            this.$message({
              type: 'warning',
              showClose: true,
              message: '当前暂无角色数据！',
              offset: 300
            })
          }

          this.roleTreeMap = roleTreeMap || {}
          this.allRolesMap = allRolesMap || {}
          this.allRolesCode2RolesIDMap = allRolesCode2RolesIDMap || {}

          let virtualRoleID = this.allRolesCode2RolesIDMap[COMPANY_READER_ROLE_CODE]
          let companyReaderRole = this.companyReaderRole

          if (virtualRoleID !== undefined) {
            companyReaderRole = {
              roleID: virtualRoleID,
              roleSummaryCn: allRolesMap[virtualRoleID]
            }
          }

          this.companyReaderRole = companyReaderRole

          return this.fetchUserAuthorizationDetails()
        })
        .catch(err => {
          return Promise.reject(err)
        })
        .then(res => {
          this.isLoading = false
          let { staffData, userRoleConfigList } = res

          this.staff = staffData
          this.roleConfigData = userRoleConfigList

          if (this.roleConfigData.length === 0) {
            this.roleConfigData.push(JSON.parse(JSON.stringify(this.rowTemplate)))
          } else {
            this.roleConfigData.forEach(item => {
              // 计算用户在哪几个公司上任职
              if (item.permissionOrgIDs.length > 0) {
                item.companyList = this.computedUserAuthorizationCompanyList(item.permissionOrgIDs)
              }
            })
          }

          // this.computedDisplayOrgNameAndCount(userRoleConfigList)
        })
        .catch(err => {
          this.isLoading = false
          console.error(this.$route.name + ' fetchAllInfo() err: ', err)
          this.$message({
            type: 'error',
            showClose: true,
            message: (err && err.message) || '连接到服务器失败，请稍后重试！',
            offset: 300
          })
        })
    },

    // 获取系统中所有组织节点
    fetchAllOrgList () {
      return new Promise((resolve, reject) => {
        if (this.plotMgmtData.length > 0) {
          // 若已经获取过则不再重新获取
          resolve(this.plotMgmtData)
          return
        }

        getRequest(URL_ALL_PLOTMGMT)
          .then(res => {
            if (!res || !res.data || !Array.isArray(res.data) || res.code !== 0) {
              console.error(this.$route.name + ' fetchAllOrgList err: ', res)
              return reject(new Error(res.message || '服务器异常！'))
            }

            if (res.data.length === 0) {
              return resolve([])
            }

            let orgTreeList = []

            try {
              orgTreeList = this._convertOrgTreeDto2Vo(res.data)
            } catch (error) {
              console.error(this.$route.name + ' _convertOrgTreeDto2Vo fail: ', error)
              return reject(new Error(error.message || '服务器数据异常！'))
            }

            resolve(orgTreeList)
          })
          .catch(err => {
            console.error(this.$route.name + ' fetchAllOrgList fail: ', err)
            reject(new Error(err.message || '服务器异常！'))
          })
      })
    },

    _convertOrgTreeDto2Vo (orgList) {
      let arrList = JSON.parse(JSON.stringify(orgList))

      // 创建可以快速查找每个组织节点关系的Map
      let orgID2OrgNameMap = {}

      for (let i = 0; i < arrList.length; i++) {
        let item = arrList[i]
        item.isPlotMgmt = item.type === OrganizationTypeEnum.PLOT_MANAGEMENT.value

        if (!item.parentID) {
          item.name = '所有公司'
        }

        if (!orgID2OrgNameMap[item.id]) {
          orgID2OrgNameMap[item.id] = { ...item }
          delete orgID2OrgNameMap[item.id].children
        }

        item.orgNodeName = item.name
        item.nodeID = item.id

        delete item.name
        delete item.id

        if (!item.parentID) {
          // 将根节点留在数组里
          continue
        } else {
          // 拿出非根节点做关联
          arrList.splice(i, 1)
          i--
        }

        arrList.some(node => {
          // 将item插入对应父节点(node)
          if (this.findChildren(node, item)) {
            return true
          }
        })
      }

      this.orgID2OrgNameMap = orgID2OrgNameMap

      return arrList
    },

    /**
     * @description 在传入节点(node)及其后代节点中查找item的父节点，找到后将item插入父节点并返回true，否则返回false
     * @param {Object} node 树中的任意节点
     * @param {Object} item 需要被插入的节点
     * @returns {Boolean} 是否在node中正确插入了item
     */
    findChildren (node, item) {
      if (!node) {
        return false
      }

      if ((node.nodeID || node.id) === item.parentID) {
        if (node.children) {
          node.children.push(item)
        } else {
          node.children = [item]
        }

        return true
      } else if (node.children) {
        for (let i = 0; i < node.children.length; i++) {
          if (this.findChildren(node.children[i], item)) {
            return true
          }
        }
      }

      return false
    },

    // 获取系统中所有角色
    fetchAllRoles () {
      return new Promise((resolve, reject) => {
        if (Object.keys(this.roleTreeMap).length > 0 && Object.keys(this.allRolesMap).length > 0 &&
           Object.keys(this.allRolesCode2RolesIDMap.length > 0)) {
          // 若已经获取过则不再重新获取
          resolve({
            roleTreeMap: this.roleTreeMap,
            allRolesCode2RolesIDMap: this.allRolesCode2RolesIDMap,
            allRolesMap: this.allRolesMap
          })
          return
        }

        getRequest(URL_ALL_ROLES)
          .then(res => {
            if (!res || !res.data || res.code !== 0) {
              console.error(this.$route.name + ' fetchAllRoles err: ', res)
              return reject(new Error(res.message || '服务器异常！'))
            }

            let roleTreeMap = {}

            try {
              roleTreeMap = this._convertRoleMapDto2Vo(res.data)
            } catch (error) {
              console.error(this.$route.name + ' _convertRoleMapDto2Vo fail: ', error)
              return reject(new Error(error.message || '服务器数据异常！'))
            }

            resolve(roleTreeMap)
          })
          .catch(err => {
            console.error(this.$route.name + ' fetchAllRoles fail: ', err)
            reject(new Error(err.message || '服务器异常！'))
          })
      })
    },

    _convertRoleMapDto2Vo (roleMap) {
      let vo = {}
      let roleTreeMap = {}
      let allRolesMap = roleMap.allRoles
      let allRolesCode2RolesIDMap = roleMap.roleCodes

      // 处理公司角色
      if (roleMap.companyRoles) {
        Object.keys(roleMap.companyRoles).forEach(companyName => {
          let roleList = roleMap.companyRoles[companyName]

          roleList.forEach(role => {
            if (!roleTreeMap[role.companyID]) {
              roleTreeMap[role.companyID] = {
                nodeID: role.companyID,
                roleNodeName: role.companyName,
                parentID: null,
                children: [],
                childrenMap: {}
              }
            }

            roleTreeMap[role.companyID].children.push({
              nodeID: role.roleID,
              roleNodeName: role.roleSummaryCn,
              parentID: role.companyID
            })

            // 创建一个快捷查找子节点id--name的Map
            roleTreeMap[role.companyID].childrenMap[role.roleID] = role.roleSummaryCn
          })

          // 保存公用角色公司 id
          if (companyName === '公用') {
            this.publicOrgRoleID = roleList[0].companyID
          }
        })
      }

      vo.roleTreeMap = roleTreeMap
      vo.allRolesMap = allRolesMap
      vo.allRolesCode2RolesIDMap = allRolesCode2RolesIDMap

      return vo
    },

    fetchUserAuthorizationDetails () {
      let params = {
        userID: this.userID
      }

      return new Promise((resolve, reject) => {
        getRequest(URL_USER_AUTHORIZATION_DETAILS, params)
          .then(res => {
            if (!res || !res.data || res.code !== 0) {
              console.error(this.$route.name + ' fetchUserAuthorizationDetails err: ', res)
              return reject(new Error(res.message || '服务器异常！'))
            }

            let userAuthorizationDetailsMap = {}

            try {
              userAuthorizationDetailsMap = this._convertUserDto2Vo(res.data)
            } catch (error) {
              console.error(this.$route.name + ' _convertUserDto2Vo fail: ', error)
              return reject(new Error(error.message || '服务器数据异常！'))
            }

            resolve(userAuthorizationDetailsMap)
          })
          .catch(err => {
            console.error(this.$route.name + ' fetchUserAuthorizationDetails fail: ', err)
            reject(new Error(err.message || '服务器异常！'))
          })
      })
    },

    _convertUserDto2Vo (userData) {
      let vo = {}
      let staffData = {}
      let userRoleConfigList = []

      // 处理用户基本信息
      staffData.userCompanyID = userData.userCompanyID
      staffData.userCompanyName = userData.userCompanyName
      staffData.userID = userData.userID
      staffData.userName = userData.userName
      staffData.userPhoneNumber = userData.userPhoneNumber

      // 处理用户角色权限列表
      userData.groups.forEach(item => {
        userRoleConfigList.push({
          companyList: [],
          permissionOrgIDs: item.orgIDs || [],
          transitive: item.transitive,
          permissionRoleID: item.roleID,
          onlyUserOwnData: typeof item.usedByCreator === 'boolean' ? item.usedByCreator : null,
          timeRange: null,
          permissionByDesignationIDs: (item.resourceIDRestriction && item.resourceIDRestriction.resourceIDs && item.resourceIDRestriction.resourceIDs.join(',')) || '',
          userSelectPlotMgmtList: []
          // orgNodesNameList: [],
        })

        if (item.resourceCreateTimestampRestriction) {
          userRoleConfigList[userRoleConfigList.length - 1].timeRange = [
            item.resourceCreateTimestampRestriction.startTimestamp,
            item.resourceCreateTimestampRestriction.endTimestamp
          ]
        }
      })

      vo.staffData = staffData
      vo.userRoleConfigList = userRoleConfigList
      return vo
    },

    // 计算并返回用户选中的所有组织节点ID对应的公司ID列表，permissionOrgIDs：用户选中的所有组织节点ID列表
    computedUserAuthorizationCompanyList (permissionOrgIDs) {
      let arr = []
      let companyIDList = []

      if (permissionOrgIDs.length === 0) {
        return []
      }

      permissionOrgIDs.forEach(orgID => {
        // 查找每一个组织节点的根节点
        let companyID = this.findRootNodeID(orgID, this.orgID2OrgNameMap)
        if (companyID) {
          arr.push(companyID)
        }
      })

      companyIDList = new Set(arr) // 去重
      companyIDList = Array.from(companyIDList)

      return companyIDList
    },

    // 计算并返回用户选中的所有组织节点ID对应的基地ID列表，permissionOrgIDs：用户选中的所有组织节点ID列表
    computedUserSelectPlotMgmtList (permissionOrgIDs) {
      let plotMgmtLists = []
      this.plotMgmtList = []

      if (permissionOrgIDs.length === 0) {
        return []
      }

      permissionOrgIDs.forEach(orgID => {
        // 查找每一个组织节点的所有子节点
        let node = this.$refs.orgTree.getNode(orgID)
        this.computedLeafNodeCount(node)
      })

      plotMgmtLists = new Set(this.plotMgmtList) // 去重
      plotMgmtLists = Array.from(plotMgmtLists)
      this.plotMgmtList = []

      return plotMgmtLists
    },

    // 计算node中所有叶子节点数量
    computedLeafNodeCount (node) {
      if (node.data.isPlotMgmt) {
        this.plotMgmtList.push(node.data.nodeID)
      }

      if (node.childNodes.length > 0) {
        node.childNodes.forEach(ele => {
          this.computedLeafNodeCount(ele)
        })
      }
    },

    // computedDisplayOrgNameAndCount (userRoleConfigList) {
    //   userRoleConfigList.forEach(rowData => {
    //     if (rowData.permissionOrgIDs.length > 0) {
    //       let { orgNodesNameList, userSelectPlotMgmtList } = this.findUserSelectedOrgDetail(rowData.permissionOrgIDs)
    //       rowData.orgNodesNameList = orgNodesNameList
    //       rowData.userSelectPlotMgmtList = userSelectPlotMgmtList
    //     }
    //   })
    // },

    // findUserSelectedOrgDetail (permissionOrgIDs) {
    //   let orgNodesNameList = []
    //   let userSelectPlotMgmtList = 0

    //   permissionOrgIDs.forEach(orgID => {
    //     let rootNodeID = ''
    //     let leafNodeIDs = []

    //     rootNodeID = this.findRootNodeID(orgID)

    //     leafNodeIDs.forEach(leafID => {
    //       orgNodesNameList.push(this.findOrgNodesName(leafID))
    //     })
    //   })
    // },

    // findOrgNodesName (nodeID) {
    //   let orgID2OrgNameMap = this.orgID2OrgNameMap

    //   if (!nodeID) {
    //     return ''
    //   }

    //   if (orgID2OrgNameMap[nodeID]) {
    //     return this.findOrgNodesName(orgID2OrgNameMap[nodeID].parentID) + orgID2OrgNameMap[nodeID].name
    //   }
    // },

    /**
     * @description 在一个存储了树中所有节点的Map中查找指定节点ID的根节点ID(更新为查找公司节点而不是根节点)
     * @param {Number} nodeID 指定节点ID
     * @param {Object} treeMap 存储了树中所有节点的Map
     * @returns {Number} 根节点ID
     */
    findRootNodeID (nodeID, treeMap) {
      if (treeMap[nodeID]) {
        if (treeMap[nodeID].parentID && treeMap[nodeID].parentID !== this.rootOrgID) {
          // 查找公司节点而不是根节点
          return this.findRootNodeID(treeMap[nodeID].parentID, treeMap)
        } else {
          return treeMap[nodeID].id
        }
      }
    },

    // 在员工权配置表中添加一行
    addTableRow () {
      this.roleConfigData.push(JSON.parse(JSON.stringify(this.rowTemplate)))
    },

    // 在员工权配置表中删除一行
    onDeleteTableRow (index) {
      let roleConfigRow = this.roleConfigData[index]

      // 如果该行还没产生数据，则直接删除
      if (roleConfigRow.permissionOrgIDs.length === 0 &&
        !roleConfigRow.permissionRoleID &&
        (roleConfigRow.onlyUserOwnData === null || roleConfigRow.onlyUserOwnData === '') &&
        (!roleConfigRow.timeRange || roleConfigRow.timeRange.length === 0) &&
        roleConfigRow.permissionByDesignationIDs.length === 0) {
        this.roleConfigData.splice(index, 1)
        return
      }

      this.$confirm('确定删除这行配置吗？', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          this.roleConfigData.splice(index, 1)
        })
        .catch(ignore => {})
    },

    // 为用户提供的快捷操作，快速创建对公司授权行
    onShortcutsCreateRow (index) {
      let permissionOrgIDs = this.roleConfigData[index].permissionOrgIDs
      this.currRowIndex = index

      if (permissionOrgIDs.length === 0) {
        this.$message({
          type: 'warning',
          showClose: true,
          message: '请选择授权组织！',
          offset: 300
        })
        return
      }

      this.shortcutsDialogVisible = true
    },

    onShortcutsCancel () {
      this.shortcutsSelectValue = null
      this.shortcutsDialogVisible = false
    },

    onShortcutsConfirm () {
      let shortcutsSelectValue = this.shortcutsSelectValue
      let shortcutsRow = JSON.parse(JSON.stringify(this.roleConfigData[this.currRowIndex]))

      if (!shortcutsSelectValue) {
        this.$message({
          type: 'warning',
          showClose: true,
          message: '请选择一个选项！',
          offset: 300
        })
        return
      }

      shortcutsRow.permissionOrgIDs = [].concat(shortcutsRow.companyList)
      shortcutsRow.permissionRoleID = this.companyReaderRole.roleID
      shortcutsRow.transitive = Number(shortcutsSelectValue) === 2

      this.roleConfigData.splice(this.currRowIndex + 1, 0, shortcutsRow)

      this.shortcutsSelectValue = null
      this.shortcutsDialogVisible = false
    },

    onSelectOrg (index) {
      this.currCompanyList = this.roleConfigData[index].companyList // 保存修改组织节点之前的公司列表
      this.currRowIndex = index
      this.orgDialogVisible = true
      ++this.orgKey // 每次打开Dialog都重新加载el-tree组件
      this.plotMgmtDataCopy = JSON.parse(JSON.stringify(this.plotMgmtData)) // 深拷贝一份初始数据使用

      if (!this.isFirstOrgTree) {
        this.loadOrgNode(this.node, this.resolve) // 第二次及以后打开Dialog时el-tree重新加载所有节点
      }

      setTimeout(() => {
        // 在el-tree中设置选中节点并将选中节点的所有后代节点设置为disable
        this.setDisable2CheckedKeysChild()
        this.roleConfigData[index].userSelectPlotMgmtList = this.computedUserSelectPlotMgmtList(this.roleConfigData[index].permissionOrgIDs)

        if (this.allPlotMgmtCount === 0) {
          let list = this.computedUserSelectPlotMgmtList([this.rootOrgID])
          this.allPlotMgmtCount = list.length
        }
      }, 0)
    },

    onSelectOrgCancel () {
      this.userSelectedOrgIDs = []
      this.currCompanyList = []
      this.orgDialogVisible = false
    },

    // 保存用户选中的orgID列表
    onSelectOrgConfirm () {
      let oldOrgIDs = [].concat(this.roleConfigData[this.currRowIndex].permissionOrgIDs)
      let newOrgIDs = [].concat(this.userSelectedOrgIDs)

      if (oldOrgIDs.sort().toString() !== newOrgIDs.sort().toString() && this.roleConfigData[this.currRowIndex].timeRange &&
      this.roleConfigData[this.currRowIndex].timeRange.length === 2) {
        // 为了配置安全起见，改变组织节点时应清空时间权限的值，但是为了操作方便，暂时保留时间期限
        /*
        this.roleConfigData[this.currRowIndex].timeRange = []
        this.$message({
          type: 'warning',
          showClose: true,
          message: '请重新选择时间权限！',
          offset: 200
        })
        */
      }

      this.roleConfigData[this.currRowIndex].permissionOrgIDs = this.userSelectedOrgIDs

      if (this.userSelectedOrgIDs.length > 0) {
        this.roleConfigData[this.currRowIndex].companyList = this.computedUserAuthorizationCompanyList(this.userSelectedOrgIDs)

        let oldCompanyList = ([].concat(this.currCompanyList)).sort().toString()
        let newCompanyList = ([].concat(this.roleConfigData[this.currRowIndex].companyList)).sort().toString()
        let roleID = this.roleConfigData[this.currRowIndex].permissionRoleID

        if (oldCompanyList !== newCompanyList && roleID) {
          // let publicOrg = this.roleTreeMap[this.publicOrgRoleID]
          // if (publicOrg && !publicOrg.childrenMap[roleID]) {
          // 为了配置安全起见，当选择的组织节点发生变化导致公司变化时，应当清空角色并重新选择，但是为了操作方便，暂时保留
          /*
          this.roleConfigData[this.currRowIndex].permissionRoleID = ''
          this.$message({
            type: 'warning',
            showClose: true,
            message: '请重新选择员工角色！',
            offset: 300
          })
          */
          // }
        }
      } else {
        this.roleConfigData[this.currRowIndex].companyList = []
        this.roleConfigData[this.currRowIndex].permissionRoleID = ''
      }

      this.userSelectedOrgIDs = []
      this.currCompanyList = []
      this.orgDialogVisible = false
    },

    // 在el-tree中设置选中节点并将选中节点的所有后代节点设置为disable
    setDisable2CheckedKeysChild () {
      let permissionOrgIDs = this.roleConfigData[this.currRowIndex].permissionOrgIDs
      this.userSelectedOrgIDs = JSON.parse(JSON.stringify(permissionOrgIDs))

      this.$refs.orgTree.setCheckedKeys(permissionOrgIDs) // 通过el-tree实例方法初始化设置已选中节点

      permissionOrgIDs.forEach(nodeID => {
        let node = this.$refs.orgTree.getNode(nodeID) // 通过el-tree实例方法拿到每一个节点

        if (node) {
          this.changeAllChildNodeState(node.data, true, true) // 将某节点下所有后代节点均设置为disable
        }
      })
    },

    onSelectRole (index) {
      if (this.roleConfigData[index].companyList.length === 0) {
        this.$message({
          type: 'warning',
          showClose: true,
          message: '请先选择授权组织！',
          offset: 300
        })

        return
      }

      this.currRowIndex = index
      this.roleDialogVisible = true
      ++this.roleKey // 每次打开Dialog都重新加载el-tree组件

      let roleTree = []
      roleTree.push(this.roleTreeMap[this.publicOrgRoleID]) // 角色树中放入公用角色

      if (this.roleConfigData[index].companyList.length === 1 && this.roleConfigData[index].companyList[0] !== this.rootOrgID) {
        // 如果只选中了一个公司，且不是虚拟根节点，则将该公司下所有角色加入角色树
        if (this.roleTreeMap[this.roleConfigData[index].companyList[0]]) {
          roleTree.push(this.roleTreeMap[this.roleConfigData[index].companyList[0]])
        }
      }

      this.roleTreeData = JSON.parse(JSON.stringify(roleTree))

      if (!this.isFirstRoleTree) {
        this.loadRoleNode(this.node, this.resolve) // 第二次及以后打开Dialog时el-tree重新加载所有节点
      }

      this.defaultCheckedRoleArray = [this.roleConfigData[index].permissionRoleID]
    },

    onSelectRoleCancel () {
      this.roleDialogVisible = false
    },

    onSelectRoleConfirm () {
      let role = this.$refs.roleTree.getCheckedNodes()
      let oldRoleID = this.roleConfigData[this.currRowIndex].permissionRoleID

      if (role.length === 0) {
        this.$message({
          type: 'warning',
          showClose: true,
          message: '请选择一个角色！',
          offset: 200
        })
        return
      }

      let newRoleID = role[0].nodeID

      if (oldRoleID !== newRoleID && this.roleConfigData[this.currRowIndex].timeRange &&
      this.roleConfigData[this.currRowIndex].timeRange.length === 2) {
        // 为了配置安全起见，改变用户角色改变时应清空时间权限数据的值，但是为了操作方便，暂时保留时间期限
        /*
        this.roleConfigData[this.currRowIndex].timeRange = []
        this.$message({
          type: 'warning',
          showClose: true,
          message: '请重新选择时间权限！',
          offset: 300
        })
        */
      }

      this.roleConfigData[this.currRowIndex].permissionRoleID = role[0].nodeID
      this.roleDialogVisible = false
    },

    onDataAuthSelectChange (e, index) {
      if (this.roleConfigData[index].timeRange &&
      this.roleConfigData[index].timeRange.length === 2) {
        // 为了配置安全起见，数据权限改变时应清空时间权限数据的值，但是为了操作方便，暂时保留时间期限
        /*
        this.roleConfigData[index].timeRange = []
        this.$message({
          type: 'warning',
          showClose: true,
          message: '请重新选择时间权限！',
          offset: 200
        })
        */
      }
    },

    // 当用户点击某个节点时，存储该节点所在树结构中，所有发生变化的节点的ID与状态构成的列表
    onOrgNodeCheckStateChange (node, isCurrNodeSelected) {
      this.nodesPreCheck.push({
        nodeID: node.nodeID,
        selected: isCurrNodeSelected
      })
    },

    onOrgNodeCheck (selectedNode) {
      console.log(this.$route.name + ' onOrgNodeCheck selectedNode: ', selectedNode)

      for (let i = this.nodesPreCheck.length - 1; i >= 0; i--) { // 由于最新状态的 node在 nodesPreCheck中的最后，因此倒序遍历
        let currNode = this.nodesPreCheck[i]

        // 找到当前用户点击的节点的状态
        if (selectedNode.nodeID === currNode.nodeID) {
          if (currNode.selected) {
            this.userSelectedOrgIDs.push(selectedNode.nodeID)

            if (selectedNode.isPlotMgmt) {
              this.roleConfigData[this.currRowIndex].userSelectPlotMgmtList.push(selectedNode.nodeID)
            }

            // 若选择当前节点，则将当前节点的所有后代节点disable设置为true
            this.changeAllChildNodeState(selectedNode, true, true)

            // 重新设置选中节点
            this.$refs.orgTree.setCheckedKeys(this.userSelectedOrgIDs)

            // 若选中当前节点导致前代节点被选中，则选中前代节点来代替所有后代节点
            // this.handleChildNodeAllSelected(selectedNode)
          } else {
            this.userSelectedOrgIDs.splice(this.userSelectedOrgIDs.indexOf(selectedNode.nodeID), 1)

            if (selectedNode.isPlotMgmt) {
              this.roleConfigData[this.currRowIndex].userSelectPlotMgmtList.splice(this.roleConfigData[this.currRowIndex].userSelectPlotMgmtList.indexOf(selectedNode.nodeID), 1)
            }

            // 若取消选择当前节点，则将当前节点的所有后代节点disable设置为false
            this.changeAllChildNodeState(selectedNode, false, true)
          }

          let plotMgmtList = this.roleConfigData[this.currRowIndex].userSelectPlotMgmtList
          plotMgmtList = new Set(plotMgmtList) // 去重
          this.roleConfigData[this.currRowIndex].userSelectPlotMgmtList = Array.from(plotMgmtList)

          break
        }
      }

      this.nodesPreCheck = []
    },

    /**
    * @description 将传入节点的所有子节点或包括所有后代节点的disable设置为true或false，当设置为true时，从存储列表中删除这些节点
    * @param {Object} node 传入的树节点
    * @param {Boolean} isDisabled disable设置为true或false
    * @param {Boolean} isRecursive 是否对所有后代节点做操作，false则只对子节点做操作
    */
    changeAllChildNodeState (node, isDisabled, isRecursive) {
      if (node.children) {
        node.children.forEach(el => {
          if (isRecursive) {
            this.changeAllChildNodeState(el, isDisabled, isRecursive)
          }

          if (isDisabled) {
            if (el.isPlotMgmt) {
              this.roleConfigData[this.currRowIndex].userSelectPlotMgmtList.push(el.nodeID)
            }

            // 此时已选中了父节点，因此删除存储列表中之前选中的子节点
            let nodeIDIdx = this.userSelectedOrgIDs.indexOf(el.nodeID)

            if (nodeIDIdx !== -1) {
              this.userSelectedOrgIDs.splice(nodeIDIdx, 1)
            }
          } else {
            if (el.isPlotMgmt) {
              this.roleConfigData[this.currRowIndex].userSelectPlotMgmtList.splice(this.roleConfigData[this.currRowIndex].userSelectPlotMgmtList.indexOf(el.nodeID), 1)
            }
          }

          this.$set(el, 'disabled', isDisabled)
        })
      }
    },

    // 递归处理某节点的所有后代节点都被选中的情况
    handleChildNodeAllSelected (selectedNode) {
      if (!selectedNode) {
        return
      }

      if (selectedNode.parentID || (selectedNode.data && selectedNode.data.parentID)) {
        let parentNode = this.$refs.orgTree.getNode(selectedNode.parentID || selectedNode.data.parentID)

        if (!parentNode) {
          return
        }

        // 检查是否当前节点的所有子节点已经被选中
        let ifChildNodeAllSelected = parentNode.childNodes.every(cNode => cNode.checked)

        if (ifChildNodeAllSelected) {
          // 若该节点的所有子节点被选中，则将该节点存储进存储列表(this.userSelectedOrgIDs)，并将所有子节点ID删除且设置为disable
          this.userSelectedOrgIDs.push(parentNode.data.nodeID)
          this.changeAllChildNodeState(parentNode.data, true, false)

          // 重新设置选中节点
          this.$refs.orgTree.setCheckedKeys(this.userSelectedOrgIDs)

          // 继续递归检查是否上一级节点的所有子节点也被选中
          this.handleChildNodeAllSelected(parentNode)
        }
      }
    },

    onRoleNodeSelectChange (node, isCurrNodeSelected) {
      if (isCurrNodeSelected) {
        this.$refs.roleTree.setCheckedKeys([node.nodeID])
      }
    },

    // el-tree搜索节点功能
    filterNode (value, data, node) {
      console.log(this.$route.name + 'filterNode', value, data, node)
      if (!value) return true

      let parentNode = node.parent
      let labels = [node.label]
      let level = 1

      // 取到一颗树上的所有节点名称
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }

      return labels.some(label => label.indexOf(value) !== -1)
    },

    // el-tree重新加载所有节点的方法
    loadOrgNode (node, resolve) {
      this.node = node
      this.resolve = resolve
      // 每次清空所有节点，否则节点会重复
      this.node.childNodes = []
      this.isFirstOrgTree = false

      if (node.level === 0) {
        return resolve(this.plotMgmtDataCopy)
      }
    },

    // el-tree重新加载所有节点的方法
    loadRoleNode (node, resolve) {
      this.node = node
      this.resolve = resolve
      // 每次清空所有节点，否则节点会重复
      this.node.childNodes = []
      this.isFirstRoleTree = false

      if (node.level === 0) {
        return resolve(this.roleTreeData)
      }
    },

    // 保存员工权限配置表
    saveRoleConfig () {
      let roleConfigData = this.roleConfigData
      let params = {
        userID: this.userID,
        entries: []
      }

      if (roleConfigData.length === 0) {
        this.$message({ message: '请点击新增按钮并填写员工配置！', type: 'warning', showClose: true, offset: 300 })
        return
      }

      for (let i = 0; i < roleConfigData.length; i++) {
        let item = roleConfigData[i]
        let configParam = { transitive: item.transitive }

        if (item.permissionOrgIDs.length === 0) {
          this.$message({ message: `请在第 ${i + 1} 行选择授权组织！`, type: 'warning', showClose: true, offset: 300 })
          return
        }
        configParam.orgIDs = item.permissionOrgIDs

        if (!item.permissionRoleID) {
          this.$message({ message: `请在第 ${i + 1} 行选择角色权限！`, type: 'warning', showClose: true, offset: 300 })
          return
        }
        configParam.roleID = item.permissionRoleID

        if (item.onlyUserOwnData === null || item.onlyUserOwnData === '') {
          this.$message({ message: `请在第 ${i + 1} 行选择数据权限！`, type: 'warning', showClose: true, offset: 300 })
          return
        }
        configParam.usedByCreator = item.onlyUserOwnData

        if (!item.timeRange || !item.timeRange[0] || !item.timeRange[1]) {
          this.$message({ message: `请在第 ${i + 1} 行选择时间权限！`, type: 'warning', showClose: true, offset: 300 })
          return
        }
        configParam.resourceCreateTimestampRestriction = {
          startTimestamp: item.timeRange[0],
          endTimestamp: item.timeRange[1]
        }

        // 后端做了校验，若resourceIDRestriction.resourceIDs有结构但没内容则需要直接传null
        configParam.resourceIDRestriction = null
        if (item.permissionByDesignationIDs && item.permissionByDesignationIDs.length > 0) {
          let restirctedResIDArr = item.permissionByDesignationIDs.split(',')
          if (restirctedResIDArr.length > 0) {
            if (configParam.orgIDs.length !== 1) {
              this.$message({ message: `第 ${i + 1} 行设置了资源ID，该行只能选择一个组织！`, type: 'warning', showClose: true, offset: 300 })
              return
            }
            configParam.resourceIDRestriction = {
              resourceIDs: restirctedResIDArr
            }
          }
        }

        params.entries.push(configParam)
      }

      this.isLoading = true

      postRequest(URL_USER_AUTHORIZATION_DETAILS, params)
        .then(res => {
          this.isLoading = false
          if (res.code !== 0) {
            this.$message({ message: res.message || '服务器异常，保存失败！', showClose: true, offset: 300, type: 'error' })
            return
          }

          this.$message({ message: `保存成功！`, showClose: true, offset: 300, type: 'success' })
          this.fetchAllInfo()
        })
        .catch(err => {
          this.isLoading = false
          console.error(this.$route.name + ' saveRoleConfig() err', err)
          this.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    },

    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.staff-page {
  display: flex;
  flex-direction: column;
  width:100%;
  height:100%;
  padding: 15px 20px 0;
  .staff-page-main {
    flex: 1;
    width:100%;
    height:100%;
    min-height: 0;
    .staff-card-body {
      width:100%;
      height:100%;
      overflow-y: auto;
      /deep/ .el-icon-delete-solid {
        font-size: 19px;
      }
      /deep/ .el-icon-s-tools {
        font-size: 19px;
      }
      /deep/ .el-button.is-circle {
        padding: 8px;
      }
      /deep/ .el-tag--mini {
        height: 21px;
      }
      /deep/ .el-card__body {
        display: flex;
        flex-direction: column;
        width:100%;
        height:100%;
        padding: 20rpx 0;
        overflow-y: auto;
        .staff-info, .staff-incharge-plotMgmt {
          .title {
            padding-left: 20px;
            height: 40px;
            line-height: 40px;
            background-color: #f1f1f1;
            i {
              display: inline-block;
              margin-right: 10px;
            }
          }
        }
        .staff-info {
          .container {
            height: 80px;
            line-height: 80px;
            overflow: auto;
            padding-left: 20px;
            div {
              display: inline-block;
              margin-right: 100px;
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
        .staff-incharge-plotMgmt {
          flex: 1;
          position: relative;
        }
      }
    }
  }
  .staff-page-footer {
    display: flex;
    justify-content: center;
    padding: 15px 0;
    height: 60px;
  }
  .dialog-container {
    .dialog-main {
      /deep/ .el-card__header {
        padding: 10px 20px;
        background-color:#cfcbcb;
      }
      .el-input /deep/ input {
        border-radius: 32px;
      }
      .tree-container {
        margin-top: 10px;
        height: 240px;
        overflow-y: auto;
      }
      .single-select {
        /deep/ .el-tree-node{
          .is-leaf + .el-checkbox .el-checkbox__inner{
            display: inline-block;
            border-radius: 50%;
          }
          .el-checkbox .el-checkbox__inner{
            display: none;
          }
        }
      }
    }
  }
  .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    width: 230px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/staff-role-assignment/staff-role-configure.vue